import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useCountry } from '../../../components/CountrySelector';
import { Cart } from '../cart.rest';
import { useCart } from '../useCart';
import {
  UPDATE_CART_MUTATION,
  UpdateCartMutationAttributes,
  CartUpdateAction
} from './useUpdateCartMutation.rest';

export const useUpdateCartMutation = (overrideCart?: Cart) => {
  const countryCodeOriginal = useCountry().country.alpha2Code;
  const {
    cart: {
      attributes: { country2AlphaCode, countryCode }
    }
  } = useCart();
  const { cart: mojoCart } = useCart();
  const addressBasedCountryCode = country2AlphaCode || countryCode;

  const [mutate, { data, loading, error }] = useMutation(UPDATE_CART_MUTATION, {
    ...(overrideCart
      ? {
          fetchPolicy: 'no-cache'
        }
      : {})
  });

  const cart = overrideCart ? overrideCart : mojoCart;

  const updateCart = useCallback(
    async (
      actionType: CartUpdateAction,
      attributes: UpdateCartMutationAttributes,
      applePay = false
    ) => {
      const cartId = attributes.id || cart.id;

      if (!cartId) return Promise.reject('updateCartMutation: cart not found');

      return await mutate({
        variables: {
          id: cartId,
          countryCode: applePay ? addressBasedCountryCode : countryCodeOriginal,
          target: cart.attributes.version,
          input: {
            data: {
              action_type: actionType,
              attributes,
              id: cartId,
              type: 'carts'
            }
          }
        }
      });
    },
    [cart.id, cart.attributes.version, mutate, addressBasedCountryCode, countryCodeOriginal]
  );

  return [updateCart, { data, loading, error }] as const;
};
